/**
 * Format currency with space between currency symbol and number
 * @param {number} value - The numeric value to format
 * @param {string} currency - Currency code (e.g., 'EUR', 'USD')
 * @param {object} intl - React Intl instance
 * @returns {string} Formatted currency string with space
 */
export const formatCurrencyWithSpace = (value, currency, intl) => {
    if (value == null || value === undefined) return ''

    // Format the number as currency
    const formatted = intl.formatNumber(value, {
        style: 'currency',
        currency: currency
    })

    // Add space between currency symbol and number for EUR
    if (currency === 'EUR') {
        // For EUR, typically the symbol is at the end: "123,45 €"
        // But some locales put it at the start: "€123,45"

        // Check if symbol is at the start
        if (formatted.startsWith('€')) {
            return formatted.replace('€', '€ ')
        }

        // Check if symbol is at the end
        if (formatted.endsWith('€')) {
            return formatted.replace('€', ' €')
        }
    }

    // For other currencies, add space after symbol if it's at the start
    const match = formatted.match(/^([^\d\s]+)(.+)$/)
    if (match) {
        return match[1] + ' ' + match[2]
    }

    return formatted
}

/**
 * React component for FormattedNumber with space
 * Updated to use new useCurrencyFormat hook for consistency
 */
import React from 'react'
import {useCurrencyFormat} from '@epmc-mach/accelarator/overrides/app/hooks/use-currency-format'

export const FormattedNumberWithSpace = ({value, currency, ...props}) => {
    const {formatCurrency} = useCurrencyFormat()
    const formattedValue = formatCurrency(value, currency, true)

    return <span {...props}>{formattedValue}</span>
}
